(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('redeem-coupons', {
                parent: 'admin',
                url: '/redeem-coupons',
                data: {
                    authorities: ['STORE_REDEEM_COUPON'],
                    pageTitle: 'redeem-coupons.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/redeem-coupons/redeem-coupons.html',
                        controller: 'RedeemCouponsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    cupom: null,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('redeem-coupons');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            });
    }
})();
